import WeeklyMenu from './WeeklyMenu';
export default WeeklyMenu;
